import Brush from '#icons/brush-48.svg'
import EngineFilled from '#icons/engine-filled.svg'
import Kg from '#icons/kg-48.svg'
import SafetyWest from '#icons/safetyvest-48.svg'
import Configuration from '#icons/settings-multi-48.svg'
import SlideControl from '#icons/slide-control-48.svg'
import Tire from '#icons/tire-48.svg'
import TruckFront from '#icons/truck-front-1-48.svg'
import TruckFrontSensor from '#icons/truck-front-sensor-48.svg'
import Trailer from '#icons/truck-side-5-48.svg'
import TruckSide from '#icons/truck-side-6-48.svg'
import Wrench from '#icons/wrench-bold-48.svg'

export const generalGroupIcons: string[] = [TruckFront, Configuration]

export const detailedGroupIcons: string[] = [
  TruckFront,
  Kg,
  Tire,
  SlideControl,
  Wrench,
  EngineFilled,
  TruckSide,
  TruckFrontSensor,
  Trailer,
  Brush,
  SafetyWest,
]

export const factoryCodeGroupIcons: string[] = [
  TruckFront,
  Kg,
  Tire,
  SlideControl,
  Wrench,
  EngineFilled,
  TruckSide,
  TruckFrontSensor,
  Trailer,
  Brush,
  SafetyWest,
]
